import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { cx } from "@emotion/css";
const Banner = (props) => {
    const { item } = props;
    const { banner } = item;
    const { background, enabled, itemSpan, showOnDesktop, text } = banner;
    return (_jsx(_Fragment, { children: enabled === true
            ?
                _jsx("span", { className: cx(background, showOnDesktop === true ? void 0 : "desktop-hide"), dangerouslySetInnerHTML: { "__html": text }, "data-count": itemSpan })
            : _jsx(_Fragment, {}) }));
};
export { Banner };
